import { Download, Save, Upload } from 'lucide-react';
import { useState } from 'react';
import type { ConfigBackup } from '@bccomms/shared';
import { session } from '../../lib/session';
import { useStore } from '../../store';
import { Field } from '../ui';

export function BackupTab() {
  const serverName = useStore((s) => s.serverName);
  const [name, setName] = useState(serverName);
  const [msg, setMsg] = useState<string | null>(null);

  const exportConfig = async () => {
    const backup = (await session.admin('admin.config.export', {})) as ConfigBackup;
    const blob = new Blob([JSON.stringify(backup, null, 2)], { type: 'application/json' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = `bccomms-backup-${new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-')}.json`;
    a.click();
    URL.revokeObjectURL(a.href);
  };

  const importConfig = async (file: File) => {
    setMsg(null);
    try {
      const backup = JSON.parse(await file.text()) as ConfigBackup;
      if (!confirm(`Replace ALL users, channels and panels with "${file.name}" (${backup.users?.length ?? 0} users, ${backup.channels?.length ?? 0} channels)? Everyone will be re-synced.`)) return;
      await session.admin('admin.config.import', { backup });
      setMsg('Configuration imported.');
    } catch (err) {
      setMsg(`Import failed: ${err instanceof Error ? err.message : String(err)}`);
    }
  };

  return (
    <>
      <div className="admin__title">
        <h2>Backup &amp; settings</h2>
      </div>
      <div className="card" style={{ marginBottom: 16 }}>
        <div className="section-title">Server name</div>
        <div className="row">
          <Field label="Shown in every client">
            <input className="input" style={{ width: 260 }} value={name} onChange={(e) => setName(e.target.value)} />
          </Field>
          <button className="btn btn--primary" style={{ marginTop: 6 }} onClick={() => void session.admin('admin.settings.update', { serverName: name })}>
            <Save size={16} /> Save
          </button>
        </div>
      </div>
      <div className="card">
        <div className="section-title">Configuration backup</div>
        <p className="muted">Exports users (with password hashes), channels and panels as JSON. Import replaces the whole configuration.</p>
        <div className="row">
          <button className="btn btn--neutral" onClick={() => void exportConfig()}>
            <Download size={16} /> Export JSON
          </button>
          <label className="btn btn--neutral">
            <Upload size={16} /> Import JSON
            <input type="file" accept="application/json" hidden onChange={(e) => e.target.files?.[0] && void importConfig(e.target.files[0])} />
          </label>
          {msg && <span className={msg.startsWith('Import failed') ? 'error' : 'chip chip--success'}>{msg}</span>}
        </div>
      </div>
    </>
  );
}
